export const DATETIME_FORMAT = 'DD.MM.YYYY, HH:mm';

export const DATE_FORMAT = 'DD.MM.YYYY';

export const DATE_SERVER_FORMAT = 'YYYY-MM-DD';

export const DATE_ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSS';

export const TIME_FORMAT = 'HH:mm';
